<span [ngClass]="classPercentage">{{percentage}} %</span>
